import React from 'react';
import styled from 'styled-components';

const StyledError = styled.div`
  color: rgb(255, 0, 0);
  font-weight: bold;
`;

function Error({
  children = '   Ooops. Pri načítavaní nastala chyba! Skúste stránku načítať znova za pár sekúnd.',
}) {
  return <StyledError>{children}</StyledError>;
}

export default Error;
